import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

export default function AdminRoute() {
    const location = useLocation();
    const { user, isAuthenticated, isLoading } = useAuth0();

    if (isLoading) return null;
    
    if (!isAuthenticated) {
        return <Navigate to="/Login" state={{ from: location }} replace />;
    }
    
    const isAdmin = user?.['https://gluck.blog/roles']?.includes('BlogAdmin');
    if (!isAdmin) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
}